<script setup lang="ts">
import { ref } from 'vue'
import { useSectionReveal } from '../composables/useSectionReveal'
import type { LocaleCode, LocalizedCopy, ProcessStep } from '../types/site'
import { localized } from '../utils/localized'
import IconSprite from './IconSprite.vue'
import SectionTitle from './SectionTitle.vue'

defineProps<{
  steps: ProcessStep[]
  copy: LocalizedCopy
  locale: LocaleCode
  fallbackLocale: LocaleCode
  watermarkImage: string
}>()

const sectionRoot = ref<HTMLElement | null>(null)
const { active } = useSectionReveal(sectionRoot)
</script>

<template>
  <section id="process" ref="sectionRoot" class="process-section page-section">
    <SectionTitle
      eyebrow="HOW IT WORKS"
      :title="copy.process.title"
      :watermark="watermarkImage"
      inverse
    />
    <div class="process-grid">
      <article v-for="step in steps" :key="step.number" class="process-card">
        <div class="process-card__copy">
          <span class="process-card__number">{{ step.number }}</span>
          <div>
            <h3>{{ localized(step.title, locale, fallbackLocale) }}</h3>
            <p>{{ localized(step.description, locale, fallbackLocale) }}</p>
          </div>
        </div>
        <span class="icon-motion">
          <IconSprite v-if="step.sprite" :sprite="step.sprite" :active="active" />
          <img v-else class="icon-motion__image" :src="step.image" alt="" loading="lazy" decoding="async" />
        </span>
      </article>
    </div>
  </section>
</template>
